import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { CSidebar, CSidebarBrand, CSidebarNav } from "@coreui/react";
import { AppSidebarNav } from "./AppSidebarNav";
import SimpleBar from "simplebar-react";
import "simplebar/dist/simplebar.min.css";
import PropTypes from "prop-types";

const AppSidebar = ({ filteredNavs }) => {
  const dispatch = useDispatch();
  const unfoldable = useSelector((state) => state.sidebarUnfoldable);
  const sidebarShow = useSelector((state) => state.sidebarShow);

  return (
    <CSidebar
      position="fixed"
      unfoldable={unfoldable}
      visible={sidebarShow}
      onVisibleChange={(visible) => {
        dispatch({ type: "set", sidebarShow: visible });
      }}
    >
      <CSidebarBrand
        className="d-none d-md-flex"
        to="/"
        style={{ background: "white", borderRight: "2px solid #3c4b64" }}
      ></CSidebarBrand>
      <CSidebarNav style={{ backgroundColor: "#4C4C4C" }}>
        <SimpleBar>
          <AppSidebarNav items={filteredNavs} />
        </SimpleBar>
      </CSidebarNav>
    </CSidebar>
  );
};
AppSidebar.propTypes = {
  filteredNavs: PropTypes.array,
};
export default React.memo(AppSidebar);
